<img width="156" height="104" [alt]="alt" [src]="src" />
